"use client";

import { useSSOErrorStore } from "@faire/deprecated-retailer-visitor-shared/stores/domain/SSO/useSSOErrorStore";
import { useStrictLocalization } from "@faire/web/common/localization";
import { useRef } from "react";

/**
 * Runs once Providers have been initialized.
 */
export const useInitializeLocalization = () => {
  const { setStrictLocalize } = useSSOErrorStore();
  const { strictLocalize } = useStrictLocalization();
  const didSet = useRef(false);

  // NOTE(Blair): We want this to only run once,
  // but we also want it to run in SSR (hence no useEffect)
  if (!didSet.current) {
    setStrictLocalize(strictLocalize);
    didSet.current = true;
  }
};
